module.exports = __webpack_public_path__ + "img/maori.01cbe97c.svg";